import { render } from "./AppWrapperView.vue?vue&type=template&id=63543c12"
import script from "./AppWrapperView.vue?vue&type=script&lang=js"
export * from "./AppWrapperView.vue?vue&type=script&lang=js"

import "./AppWrapperView.vue?vue&type=style&index=0&id=63543c12&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__